import e from"./Highlight.vue_vue&type=script&lang.js";import{render as t}from"./Highlight.vue_vue&type=template&id=214ecb36&lang.js";e.render=t;export default e;
//# sourceMappingURL=Highlight.vue.js.map
